import Highcharts, { OptionsStackingValue } from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import graphTheme from "../../graphTheme";

export type TWaterFallModel = {
    name: string;
    y: number;
    color?: string;
    borderColor?: string;
    enableMouseTracking?: boolean;
    showInLegend?: boolean;
    dataLabels?: { enabled?: boolean };
}

type THighchartWaterfallProps = {
    nuevoData: TWaterFallModel[];
    originalData: TWaterFallModel[];
    name: string;
}

const HighchartWaterfallOverlap: React.FC<THighchartWaterfallProps> = ({ name, nuevoData, originalData }) => {
    HighchartsMore(Highcharts);
    
    const options: Highcharts.Options = {
        chart: {
            type: "waterfall",
            height: 450,
            width: null
        },
        credits: {
            enabled: false
        },
        title: {
            text: name,
        },
        xAxis: {
            type: "category",

        },
        yAxis: {
            title: {
                text: "%",
            },
        },
        legend: {
            enabled: true,
        },
        tooltip: {
            pointFormat: "<b>${point.y:,.2f}</b> %",
        },
        series: [
            {
                type: "waterfall",
                name: "Original",
                upColor: Highcharts.getOptions().colors?.[3],
                color: Highcharts.getOptions().colors?.[3],
                data: originalData,
                dataLabels: {
                    enabled: true,
                    format: "{y:.2f}%",
                    y: -10,
                    x: -30
                },
                pointPadding: 0,
                pointPlacement: 0.1,
                zIndex: 1
            },
            {
                type: "waterfall",
                name: "Nuevo",
                upColor: Highcharts.getOptions().colors?.[6],
                color: Highcharts.getOptions().colors?.[6],
                data: nuevoData,
                dataLabels: {
                    enabled: true,
                    format: "{y:.2f}%",
                    y: 10,
                    x: 30
                },
                pointPadding: 0,
                pointPlacement: -0.1,
                zIndex: 2
            }
        ],
        plotOptions: {
            waterfall: {
                opacity: 1
            }
        }
    };

    return (
        <HighchartsReact highcharts={Highcharts} options={options} inmutable={false} />
  );

}

export default HighchartWaterfallOverlap;